import { FC } from "react";
import { useWebTranslation } from "translations";
import Gutter from "ui-kit/Gutter";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";
import { TypographyVariant } from "ui-kit/Typography/types";
import { AmountToPay } from "utils/insurance/getAmountToPay";
import { getShortestLivingDiscount } from "utils/insurance/getShortestLivingDiscount";
import { formatCurrency } from "utils/utils";
import { DiscountDisclaimer } from "./DiscountDisclaimer/DiscountDisclaimer";
import { BillingIntervalText } from "./BillingIntervalText";
import Colors from "ui-kit/colors";

interface GrandPriceProps {
  amountToPay?: Pick<AmountToPay, "new"> & Pick<AmountToPay, "old">;
  billingInterval: number;
  justifyContent?: "center" | "flex-start" | "flex-end";
}

const GrandPrice: FC<GrandPriceProps> = ({
  amountToPay,
  billingInterval,
  justifyContent = "center",
}) => {
  const { t } = useWebTranslation();

  return (
    <>
      <FlexRow justifyContent={justifyContent} alignItems="baseline">
        {amountToPay?.old ? (
          <>
            <Typography variant="body3" color="grey400">
              <s>{formatCurrency(amountToPay.old)}</s>
            </Typography>
            <Gutter size={0.5} horizontal />
          </>
        ) : null}
        <Typography variant="h1">{formatCurrency(amountToPay?.new)}</Typography>
        <Gutter size={0.5} horizontal />
        <BillingIntervalText color="grey400" />
      </FlexRow>
    </>
  );
};

export default GrandPrice;
